export default {
	'no-items-to-show': 'لا توجد مواد في الخطة لهذا الشهر',
	'material-name': 'اسم المادة',
	'form-type': 'نوع النموذج',
	quantity: 'الكمية',
	classification: 'التصنيف',
}
